module.exports = __webpack_public_path__ + "img/avatar-phone.e64e0c3a.png";